import { useState, useEffect } from "react";
import moment from "moment";
import InputNumber from "../../../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../../../shared/components/inputs/InputText/InputText";
import { Link } from "react-router-dom";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import toast from "react-hot-toast";

import InputSelect from "../../../../../../../shared/components/inputs/InputSelect/InputSelect";

import { useLoading } from "../../../../../../../shared/context/LoadingContext";
import "./ModalEntradaDebito.scss";

import { fixSpaces } from "../../../../../../../shared/util/helperFunctions";
import NotaInformativa from "../../../../../../../shared/components/notaInformativa/NotaInformativa";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

const formasPagamento = [
  "Dinheiro",
  "Cheque",
  // "Cheque Visado",
  // "Transferência de crédito",
  "Internet banking",
  // "Cartão do banco",
  // "Débito direto da conta bancária",
  "Cartão de crédito",
  // "Cartão de débito",
];

function ModalEntradaDebito({
  openModalEntrada,
  handleCloseModalEntrada,
  sendRequest,
  clinicaId,
  updateEntradas,
  emitirDocEletronicoEntradas,
  auth,
  cliente,
  modoContingenciaAtivo,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalEntrada);
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);
  const [observacao, setObservacao] = useState("");
  const [categoria, setCategoria] = useState();
  const [categorias, setCategorias] = useState([]);
  const [caixa, setCaixa] = useState();
  const [caixas, setCaixas] = useState([]);
  const [permCaixas, setPermCaixas] = useState([]);

  const [dataPagamento, setDataPagamento] = useState(moment());

  const [metodoPagamento, setMetodoPagamento] = useState("Dinheiro");

  // Adicionar estados para o diálogo de confirmação
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingEmit, setPendingEmit] = useState(null);

  //CHEQUE DADOS
  const [numero, setNumero] = useState("");
  const [banco, setBanco] = useState("");
  const [dataCheque, setDataCheque] = useState(moment());
  const [nrConta, setNrConta] = useState("");

  const numeroChangeHandler = (value) => {
    setNumero(value);
  };

  const contaClienteChangeHandler = (value) => {
    setNrConta(value);
  };

  const bancoChangeHandler = (value) => {
    setBanco(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [categoriasResponse, caixasResponse] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/entrada/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          }),
        );
        setCategorias(categoriasFormatted);
        setCategoria(categoriasFormatted[0]?.id);

        // Process caixas
        const caixasFormatted = caixasResponse.caixas.map((cai) => ({
          id: cai.id,
          value: cai.caixa,
        }));

        const caixaClinica = caixasFormatted.filter(
          (c) => c.value === "Clínica",
        );

        setCaixas(caixaClinica);
        setCaixa(caixaClinica[0].id);
        setPermCaixas(caixasFormatted);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalEntrada);
  }, [openModalEntrada]);

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  const valorChangeHandler = (value) => {
    setValor(value);
  };

  const guardarEntradaHandler = async (emit) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("tipo", "reembolso");
      formData.append("clinica", clinicaId);
      formData.append("observacoes", observacao ? observacao : "");
      formData.append("valor", valor);
      formData.append("descricao", fixSpaces(descricao));
      formData.append("dataLimitePagamento", moment());
      formData.append("criadoPor", auth.userId);

      formData.append("categoria", categoria);
      formData.append("caixa", caixa);

      formData.append("cliente", cliente._id);
      formData.append("metodoPagamento", metodoPagamento);
      formData.append("dataPagamento", dataPagamento);
      formData.append("entradaRecebida", true);
      formData.append("recebidoPor", auth.userId);

      if (metodoPagamento === "Cheque") {
        //DADOS CHEQUE
        formData.append("banco", banco);
        formData.append("dataCheque", dataCheque);
        formData.append("nrCheque", numero);
        formData.append("nrContaCliente", nrConta);
      }

      //LEMBRA DE ADICIONAR COMPROVATIVO MAIS TARDE
      let entradaAdicionada;
      try {
        entradaAdicionada = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/entradas`,
          "POST",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      } catch (err) {
        console.error("err", err);
      }

      if (emit) {
        // Insere já a entrada criada na lista, para aparecer mesmo que a
        // emissão do FRE falhe. A emissão depois atualiza-a (idempotente).
        updateEntradas(entradaAdicionada.entrada, "inserir");
        emitirDocEletronicoEntradas(
          entradaAdicionada.entrada,
          null,
          "FRE",
          "inserir",
        );
      } else {
        toast.success("Entrada adicionada com sucesso!");
        updateEntradas(entradaAdicionada.entrada, "inserir");
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmitting(false);
      handleCloseModalEntrada();
    }
  };

  const metodoPagamentoChangeHandler = (valor) => {
    setMetodoPagamento(valor);
    if (valor === "Dinheiro") {
      const caixaClinica = permCaixas.filter((c) => c.value === "Clínica");
      setCaixas(caixaClinica);
      setCaixa(caixaClinica[0].id);
    } else {
      const caixasSemClinica = permCaixas.filter((c) => c.value !== "Clínica");
      const caixaClinica = permCaixas.find((c) => c.value === "Clínica");
      setCaixas(caixasSemClinica);
      if (caixa === caixaClinica.id) setCaixa(caixasSemClinica[0].id);
    }
  };

  const preGuardarEntradaHandler = (e, emit) => {
    if (valor === 0 || valor < 0) {
      toast.error("O valor da entrada não pode ser 0 ou menor que 0.");
    } else if (!descricao || descricao.trim() === "") {
      toast.error("Introduza a descrição");
    } else if (!cliente) {
      toast.error("Escolha o Cliente");
    } else if (!categoria) {
      toast.error("Introduza uma categoria");
    } else if (!caixa) {
      toast.error("Introduza uma categoria");
    } else if (!moment.isMoment(dataPagamento) || !dataPagamento.isValid()) {
      toast.error("Introduza a data de pagamento corretamente");
    } else if (!isSubmitting) {
      if (emit && cliente?.nome !== cliente?.nomeFiscal) {
        // Guardar a operação pendente e mostrar o diálogo
        setPendingEmit(emit);
        setConfirmDialogOpen(true);
      } else {
        // Prosseguir normalmente
        setIsSubmitting(true);
        guardarEntradaHandler(emit);
      }
    }
  };

  // Handlers para o diálogo
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
    setPendingEmit(null);
  };

  const handleConfirmDialogConfirm = () => {
    setConfirmDialogOpen(false);

    // Executar a operação pendente
    if (pendingEmit) {
      setIsSubmitting(true);
      guardarEntradaHandler(pendingEmit);
    }

    setPendingEmit(null);
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalEntrada}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-entrada__modal"
          id="modal__adicionar-entrada"
        >
          <h1 className="fluxo-atendimento__modal__titulo">Nova entrada</h1>

          {/* Uma entrada é o sítio errado para receber um tratamento, e o
              engano não dá erro nenhum: o dinheiro fica registado, mas fora do
              orçamento — que continua a aparecer por receber. */}
          <NotaInformativa
            titulo="O que é uma entrada"
            style={{ margin: "0 0 18px", gridColumn: "1/-1" }}
          >
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              <li>
                Uma entrada é um pagamento que{" "}
                <strong>não pertence a nenhum orçamento</strong> — o
                recebimento de um <strong>tratamento isolado</strong>, a venda
                de um artigo, ou um valor cobrado à parte.
              </li>
              <li>
                Se o que quer registar é o pagamento de um{" "}
                <strong>tratamento orçamentado</strong>, não o lance aqui:{" "}
                <strong>aprove o orçamento</strong>, se ainda não estiver
                aprovado, e <strong>receba na parcela</strong> correspondente.
              </li>
              <li>
                Lançado como entrada, o valor entra na caixa à mesma, mas o
                orçamento fica <strong>por receber</strong> e a conta do cliente
                nunca fecha.
              </li>
            </ul>
          </NotaInformativa>

          <div className="adicionar-entrada__modal__container">
            <InputText
              className="adicionar-entrada__modal__container--span2"
              label="Descrição *"
              initialValue={descricao}
              handleChange={descricaoChangeHandler}
            />

            <InputNumber
              className="adicionar-entrada__modal__container--span1"
              label="Valor *"
              initialValue={valor}
              handleChange={valorChangeHandler}
            />

            <InputSelect
              className="adicionar-entrada__modal__container--span1"
              label="Método de pagamento"
              initialValue={metodoPagamento}
              handleChange={metodoPagamentoChangeHandler}
              items={formasPagamento}
            />

            {categorias && categoria && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria</label>
                <Link to={`../../configuracoes/categoriasFinanceiro`}>
                  <ControlPointIcon className="customInputPlusSign" />
                </Link>
              </div>
            )}

            {caixas && caixa && (
              <div className="customInputContainer adicionar-entrada__modal__container--span1">
                <select
                  onChange={(e) => setCaixa(e.target.value)}
                  className="customInputSelect"
                  value={caixa}
                >
                  {caixas &&
                    caixa &&
                    caixas.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Caixa</label>
                <Link to={`../../configuracoes/caixas`}>
                  <ControlPointIcon className="customInputPlusSign" />
                </Link>
              </div>
            )}

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-entrada__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data de pagamento*"
                inputFormat="DD-MM-YYYY"
                value={dataPagamento}
                onChange={(value) => setDataPagamento(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            {metodoPagamento === "Cheque" && (
              <>
                <InputNumber
                  key="numeroCheque"
                  id="numeroCheque"
                  initialValue={0}
                  label="Número Cheque*"
                  handleChange={numeroChangeHandler}
                />

                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DesktopDatePicker
                    className="valorDataCaixa__fields--field muiDatePicker"
                    label="Data*"
                    inputFormat="DD-MM-YYYY"
                    value={dataCheque}
                    onChange={(value) => setDataCheque(value)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <InputText
                  initialValue={nrConta}
                  label="Conta do cliente*"
                  handleChange={contaClienteChangeHandler}
                  notEmpty={true}
                  id="contaDoCliente"
                />
                <InputText
                  initialValue={banco}
                  label="Banco*"
                  handleChange={bancoChangeHandler}
                  notEmpty={true}
                  id="banco"
                />
              </>
            )}

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="adicionar-entrada__modal__container__textarea"
            ></textarea>
          </div>

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalEntrada}
              style={{ display: "block" }}
            >
              Fechar
            </span>

            <span
              disabled={isSubmitting}
              className="blue-button"
              onClick={preGuardarEntradaHandler}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </span>
            <span
              disabled={isSubmitting}
              className={"blue-button"}
              onClick={preGuardarEntradaHandler.bind(null, null, "emitirFRE")}
            >
              {isSubmitting
                ? "Guardando e emitindo..."
                : `Guardar e emitir FRE ${
                    modoContingenciaAtivo ? " (Contingência)" : ""
                  }`}
            </span>
          </div>
        </Box>
      </Modal>

      {/* Dialog de confirmação */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          Atenção: Nomes diferentes
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            O nome do cliente ({cliente?.nome}) e o nome fiscal (
            {cliente?.nomeFiscal}) são diferentes. Deseja prosseguir com a
            emissão do documento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDialogConfirm}
            color="primary"
            autoFocus
          >
            Prosseguir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ModalEntradaDebito;
